import type { VideoTemplate } from "./types"

export type { VideoTemplate, TemplateTextField } from "./types"

export const TEMPLATE_BADGE_CATEGORIES = {
  hot: "热门",
  new: "最新",
} as const

// 热门和最新可以同时选择，同时存在时只展示热门角标
export const getTemplateBadge = (categories: readonly string[]) =>
  categories.includes(TEMPLATE_BADGE_CATEGORIES.hot)
    ? TEMPLATE_BADGE_CATEGORIES.hot
    : categories.includes(TEMPLATE_BADGE_CATEGORIES.new)
      ? TEMPLATE_BADGE_CATEGORIES.new
      : ""

export const findTemplate = (
  identity: string | undefined,
  templates: VideoTemplate[],
): VideoTemplate | undefined =>
  identity
    ? templates.find((template) => template.templateId === identity)
    : undefined

export const getTemplateAnalyticsFields = (card: VideoTemplate) => ({
  templateId: card.templateId,
  template_title: card.title,
})

export type TemplateValues = Record<string, string> & { templateId: string }

// Reading task metadata must not require the catalog to be loaded.
export const normalizeTemplateValues = (
  value: unknown,
): TemplateValues | null => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null
  const entries = Object.entries(value)
  if (!entries.every(([, item]) => typeof item === "string")) return null
  const values = Object.fromEntries(entries) as Record<string, string>
  const identity = (values.templateId ?? values.id)?.trim()
  if (!identity) return null
  delete values.id
  return { ...values, templateId: identity }
}
